export const getUserType = (singleText: string) => {
  switch (singleText) {
    case 's':
    case 'S':
    case 'b':
    case 'B':
      return 'STUDENT'
    case 'p':
    case 'P':
      return 'PARENT'
    default:
      return 'STUDENT'
  }
}
